document.addEventListener('change', event => {
  if (event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit();
  if (event.target.matches('[data-variant-select]')) {
    const section = event.target.closest('.product-information');
    const option = event.target.selectedOptions[0];
    const button = section.querySelector('[data-product-add]');
    if (button) button.disabled = option.dataset.available !== 'true';
    const price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    const stock = section.querySelector('[data-product-stock]');
    if (stock) stock.textContent = option.dataset.available === 'true' ? stock.dataset.availableLabel : stock.dataset.soldLabel;
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
  }
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.mobile-navigation[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});
document.addEventListener('click', event => {
  const menu = document.querySelector('.mobile-navigation[open]');
  if (menu && !menu.contains(event.target)) menu.open = false;
});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('[data-product-form]')) return;
  const button = form.querySelector('[data-product-add]');
  const status = form.querySelector('[data-product-status]');
  if (!button || !window.fetch) return;
  event.preventDefault();
  button.disabled = true;
  try {
    const data = new FormData(form);
    const response = await fetch(form.action + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
    const json = await response.json();
    if (!response.ok) throw new Error(json.description || 'add');
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    if (status) { status.textContent = ''; const link = document.createElement('a'); link.href = '/cart'; link.className = 'text-link'; link.textContent = 'View bag ↗'; status.append('Added to your bag. ', link); }
  } catch (failure) {
    if (status) status.textContent = (failure && failure.message) || 'We could not add this item. Please try again.';
  } finally {
    button.disabled = false;
  }
});
